// Within this distance (miles) of current center, keep same city - no new search
export const MAP_MOVE_MIN_DISTANCE_MILES = 3;
// Pan up (px) when a pin is selected so the marker sits above the facility card overlay
export const PAN_UP_PX = 200;

export const MEDIUM_BREAKPOINT_MAX_PX = 767;
